import { AppLoading } from '@/components/AppLoading'
import { BasicContactsForm } from '@/containers/steps/poleas/SignIn/BasicContactsForm'
import { SignInForm } from '@/containers/steps/poleas/SignIn/SignInForm'
import { usePartner } from '@/context/PartnerContext'
import type { PoleasPublicBasicContacts } from '@/dtos'
import { useGetLoginInfo } from '@/hooks/usePoleasPublic'
import {
  Alert,
  Box,
  Flex,
  Grid
} from '@chakra-ui/react'
import { AuthPageLayout } from 'BrokerTsLib/src/components'
import { formatDate } from 'BrokerTsLib/src/Utils/formatDate'
import { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'


export function SignInPage() {
  const { token } = useParams()
  const navigate = useNavigate()

  const { data, error: loginInfoError } = useGetLoginInfo(token)
  const loginInfo = data?.data

  const [basicContacts, setBasicContacts] = useState<PoleasPublicBasicContacts | null>(null)
  const showBasicContacts = !!basicContacts

  const [errorMessage, setErrorMessage] = useState('')

  useEffect(() => {
    if (loginInfoError)
      setErrorMessage('Nastala chyba při načítání údajů pro přihlášení. Zkontrolujte správnost url adresy a zkuste to prosím znovu.')
  }, [loginInfoError])

  useEffect(() => {
    if (!token)
      setErrorMessage('Chybí token pro přihlášení. Zkontrolujte správnost url adresy a zkuste to prosím znovu.')
  }, [])

  const { currentPartner } = usePartner()

  if (!loginInfo && !errorMessage)
    return <AppLoading />

  return (<AuthPageLayout
    title={<>Vítá Vás<br />sjednávač UniCredit pojištění.</>}
    subtitle={<>
      Pojištění Vašeho vozidla končí současně s&nbsp;ukončením smlouvy o&nbsp;financování.
      <br />
      <br />
      {loginInfo?.pastInsuranceEnd && <>
        Poslední den Vašeho pojištění je{' '}
        <b>
          {formatDate(loginInfo.pastInsuranceEnd)}&nbsp;(včetně).
        </b>
        <br />
        <br />
      </>
      }
      Nabízíme Vám zvýhodněné pojištění od více pojistitelů.
    </>
    }
    subtitleProps={{ fontSize: 'xl', mb: 0 }}
    logo={currentPartner?.logo}
  >
    <Flex alignItems={'center'} p={4} flex={1} justifyContent={'center'}>
      <Grid
        bg="white"
        gap={8}
      >
        {errorMessage &&
          <Alert
            status='error'
            variant='left-accent'
            fontSize={'xl'}
            p={8}
          >
            {errorMessage}
          </Alert>
        }

        {!errorMessage && <>
          {!showBasicContacts && loginInfo &&
            <Box w={'400px'} mx="auto">
              <SignInForm
                token={token!}
                loginInfo={loginInfo}
                isDisabled={!!basicContacts}
                submitCallback={(data) => {
                  if (data?.isContracted) {
                    navigate('/poleas/complete')
                    return
                  }
                  else if ((data?.lastWizardStep ?? 0) > 1) {
                    navigate(`/poleas/wizard/${data.lastWizardStep}`)
                    return
                  }

                  setBasicContacts(data)
                }}
              />
            </Box>
          }

          {showBasicContacts && basicContacts && <>
            <Alert
              status='success'
              variant='left-accent'
              backgroundColor={'green.50'}
              fontSize={'xl'}
              p={8}
            >
              Zadané {loginInfo?.isRcLoginType ? 'rodné číslo' : 'IČ'} je správné. Zadejte prosím Vaše kontaktní údaje a pokračujte na nabídku.
            </Alert>

            <Box w={'400px'} mx="auto">
              <BasicContactsForm
                basicContacts={basicContacts}
                submitCallback={() => {
                  navigate('/poleas/wizard/1')
                }}
              />
            </Box>
          </>
          }
        </>}
      </Grid>
    </Flex>
  </AuthPageLayout>
  )
}

